module.exports = __webpack_public_path__ + "img/features_learner dashboards.71127cef.png";